import axios from 'axios'
import router from '@/router'
import { emitter } from '@/plugins/events/emitter'
//import store from '@/store'
//import Cookies from 'js-cookie'

export const http = axios.create({
  baseURL: `${process.env.VUE_APP_APIURL}/`,
  // SET TO FALSE WHEN USE TOKEN AUTH VIA SANCTUM
  withCredentials: false
})

http.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
  /*
  Add this header to disable sanctum EnsureFrontendRequestsAreStateful middleware
  and allow to add csrf token to each incoming request.
  ONLY USE TO TOKEN AUTH VIA SANCTUM
  */
  //noFrontendRequestsAreStateful: false
  // 'Content-Type': 'application/x-www-form-urlencoded'
  // 'Content-Type': 'multipart/form-data'
}

// ONLY USE TO TOKEN AUTH VIA SANCTUM
/* http.interceptors.request.use(function(config) {
  config.headers.Authorization = `Bearer ${Cookies.get('token')}`
  config.headers['user-guard'] = Cookies.get('guard')

  return config
}) */

http.interceptors.response.use(
  (response) => {
    return Promise.resolve(response)
  },

  (error) => {
    if (!error.response) {
      emitter.emit('message', {
        message: 'El servidor ha dejado de responder',
        color: 'danger'
      })
      return Promise.reject(error)
    }
    const { status } = error.response
    if (status === 419) {
      emitter.emit('toast', {
        message: 'Su sesión ha expirado',
        color: 'danger'
      })
      //router.push({ name: 'login' })
    }
    if (status === 401) {
      emitter.emit('toast', {
        message: 'No Autenticado',
        color: 'danger'
      })
    }
    if (status === 404) {
      emitter.emit('toast', {
        message: 'No se encontraron resultados',
        color: 'warning'
      })
    }
    if (status === 422) {
      emitter.emit('toast', {
        message: 'Existen errores y no se pudo procesar la solicitud',
        color: 'danger'
      })
    }
    if (status === 403) {
      emitter.emit('toast', {
        message: 'Usted no tiene permiso para realizar esta acción',
        color: 'danger'
      })
    }
    if (status === 500) {
      emitter.emit('toast', {
        message: 'Error interno del servidor',
        color: 'danger'
      })
    }

    return Promise.reject(error)
  }
)

export default {
  install: (app) => {
    app.config.globalProperties.$http = http
  }
}
